export default function AGB() {
  return (
    <div data-testid="page-agb">
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">Rechtliches</p>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter mt-6">
            Allgemeine Geschäftsbedingungen
          </h1>
          <p className="mt-6 text-sm text-[#757067] font-light italic">
            Stand: {new Date().toLocaleDateString("de-CH", { year: "numeric", month: "long" })}
          </p>
        </div>
      </section>

      <section>
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28 space-y-12 text-[#2C2A26]">

          <div>
            <h2 className="font-serif text-2xl font-medium">1. Geltungsbereich und Leistungsbereiche</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Leistungen von
              Lukas Stutz, Schloßstraße&nbsp;32, 64720&nbsp;Michelstadt (nachfolgend
              &bdquo;Auftragnehmer&ldquo;). Der Auftragnehmer erbringt drei voneinander
              getrennte Leistungsbereiche:
            </p>
            <ul className="mt-4 space-y-3 text-[#757067] font-light leading-relaxed">
              <li className="flex gap-3">
                <span className="text-[#BA6D52]">A</span>
                <span>
                  <b className="text-[#2C2A26]">Mietkoch für gewerbliche Auftraggeber (B2B)</b> —
                  Küchendienstleistung für Hotels, Restaurants, Gastronomiebetriebe, Caterer und
                  Veranstalter. Abrechnung nach tatsächlich geleisteten Arbeitsstunden. Hierfür
                  gelten die Ziffern&nbsp;1–3 sowie&nbsp;6–17.
                </span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#BA6D52]">B</span>
                <span>
                  <b className="text-[#2C2A26]">Privatkoch für Verbraucher (B2C)</b> —
                  Private-Dining- und Menü-Abende bei Privatpersonen zu Hause. Abrechnung zum
                  vereinbarten <b>Festpreis</b>. Hierfür gelten ergänzend und vorrangig die
                  Sonderbedingungen in Ziffer&nbsp;4.
                </span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#BA6D52]">C</span>
                <span>
                  <b className="text-[#2C2A26]">Vermittlung selbstständiger Köche</b> —
                  Zusammenführung von Gastronomiebetrieben oder Privatkunden mit selbstständigen
                  Köchen (Mietkoch-Einsätze, Private Dining, Festanstellung). Der
                  Auftragnehmer wird hier ausschließlich als <b>Vermittler</b> tätig und ist nicht
                  Vertragspartei des vermittelten Einsatzes. Hierfür gelten ergänzend und vorrangig
                  die Sonderbedingungen in Ziffer&nbsp;5.
                </span>
              </li>
            </ul>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b className="text-[#2C2A26]">Räumlicher Anwendungsbereich.</b> Der Auftragnehmer ist in
              <b> Deutschland und Österreich</b> tätig; die Vermittlung erfolgt auch grenzüberschreitend
              zwischen beiden Ländern. Diese AGB gelten für Auftraggeber und vermittelte Köche in beiden
              Ländern. Bei Einsätzen im jeweils anderen Land sind die dort geltenden gewerbe-,
              hygiene- und sozialversicherungsrechtlichen Vorschriften zu beachten; insbesondere hat
              der selbstständige Koch die erforderliche <b>A1-Bescheinigung</b> mitzuführen und – soweit
              erforderlich – eine Dienstleistungsanzeige zu erstatten. Der Auftragnehmer schuldet
              hierzu keine Rechtsberatung.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Verbraucher im Sinne dieser AGB ist jede natürliche Person, die den Vertrag zu
              überwiegend privaten Zwecken abschließt (§&nbsp;13 BGB). Unternehmer ist, wer in
              Ausübung einer gewerblichen oder selbstständigen beruflichen Tätigkeit handelt
              (§&nbsp;14 BGB). Abweichende Bedingungen des Auftraggebers werden nur wirksam, wenn
              der Auftragnehmer ihnen ausdrücklich in Textform zustimmt.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">2. Zustandekommen des Vertrags</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Mit Absenden des Anfrageformulars über die Website gibt der Auftraggeber
              ein unverbindliches Angebot ab. Ein verbindlicher Vertrag kommt erst durch
              die schriftliche Auftragsbestätigung des Auftragnehmers (per E-Mail mit
              eindeutiger Auftragsnummer) sowie die anschliessende aktive Bestätigung
              des Auftraggebers (durch Klick auf den entsprechenden Bestätigungs-Link
              in der E-Mail) zustande.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">3. Leistungsumfang</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Der Auftragnehmer erbringt ausschliesslich Unterstützungsleistungen
              in bestehenden Gastronomie-Küchen am vereinbarten Einsatzort. Eigene
              Vorbereitungsküche, Catering-Komplettleistungen oder die Bereitstellung
              von Equipment sind nicht Bestandteil des Auftrags. Der Auftraggeber
              stellt eine funktionstüchtige, hygienisch einwandfreie Arbeitsumgebung
              sicher.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">4. Sonderbedingungen Privatkoch (Verbraucher)</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Für Privatkoch-Leistungen bei Verbrauchern (Private Dining, Menü-Abende, Kochkurse
              im privaten Umfeld) gelten ergänzend und vorrangig die folgenden Regelungen:
            </p>
            <ul className="mt-4 space-y-3 text-[#757067] font-light leading-relaxed list-none">
              <li><b className="text-[#2C2A26]">4.1 Festpreis.</b> Der im Angebot ausgewiesene
                Betrag ist ein Festpreis für die beschriebene Leistung einschließlich Menüplanung,
                Einkauf, Zubereitung, Service und Küchenreinigung. Eine Nachberechnung nach
                tatsächlich geleisteten Arbeitsstunden findet nicht statt.</li>
              <li><b className="text-[#2C2A26]">4.2 Preisangaben.</b> Gegenüber Verbrauchern werden
                alle Preise als Endpreise einschließlich der gesetzlichen Umsatzsteuer und
                einschließlich aller Preisbestandteile angegeben. Zusätzlich anfallende Kosten
                (z.&nbsp;B. Warenkosten) werden im Angebot gesondert ausgewiesen.</li>
              <li><b className="text-[#2C2A26]">4.3 Personenzahl.</b> Die Kalkulation erfolgt auf
                Basis der vereinbarten Personenzahl. Änderungen sind bis <b>7&nbsp;Tage</b> vor dem
                Termin in Textform möglich; der Preis wird entsprechend angepasst. Bei einer
                Reduzierung innerhalb der letzten 7&nbsp;Tage wird der Preis der bereits
                eingekauften Waren fällig.</li>
              <li><b className="text-[#2C2A26]">4.4 Allergien und Unverträglichkeiten.</b> Der
                Auftraggeber teilt Allergien, Unverträglichkeiten und Ernährungsformen aller Gäste
                spätestens <b>5&nbsp;Tage</b> vor dem Termin vollständig in Textform mit. Ohne
                rechtzeitige Mitteilung kann eine allergenfreie Zubereitung nicht gewährleistet
                werden. Eine vollständige Ausschließbarkeit von Spurenkontaminationen in einer
                privaten Küche ist technisch nicht möglich.</li>
              <li><b className="text-[#2C2A26]">4.5 Küche und Mitwirkung.</b> Der Auftraggeber
                stellt eine funktionsfähige, hygienisch nutzbare Küche mit Herd, Backofen,
                Arbeitsfläche, Kühlmöglichkeit, Warmwasser und Strom sowie Geschirr und Besteck für
                die vereinbarte Personenzahl bereit, sofern nichts anderes vereinbart ist. Werden
                erforderliche Voraussetzungen nicht geschaffen, kann der Auftragnehmer die Leistung
                anpassen; ein Anspruch auf Preisminderung entsteht dadurch nicht.</li>
              <li><b className="text-[#2C2A26]">4.6 Warenbeschaffung.</b> Der Einkauf erfolgt durch
                den Auftragnehmer, sofern nicht ausdrücklich anders vereinbart. Nicht verbrauchte
                Lebensmittel verbleiben beim Auftraggeber. Aus Gründen der Lebensmittelhygiene
                übernimmt der Auftragnehmer keine Haftung für Speisen, die nach Ende des Einsatzes
                weiterverwendet oder aufbewahrt werden.</li>
              <li><b className="text-[#2C2A26]">4.7 Anzahlung.</b> Eine Anzahlung von bis zu
                <b>&nbsp;30&nbsp;%</b> des Auftragswerts kann vereinbart werden; sie wird auf den
                Endpreis angerechnet. Der Termin gilt nach Eingang der Anzahlung als verbindlich
                reserviert.</li>
              <li><b className="text-[#2C2A26]">4.8 Stornierung durch den Verbraucher.</b> Mit der
                Auftragsbestätigung wird der Termin exklusiv für den Auftraggeber reserviert; der
                Auftragnehmer vergibt diesen Tag nicht mehr an andere Kunden. Eine Stornierung ist
                bis einschließlich <b>22&nbsp;Kalendertage</b> vor dem vereinbarten Termin
                kostenfrei möglich. Bei späterer Stornierung nach Ablauf der Widerrufsfrist
                (Ziffer&nbsp;15) kann der Auftragnehmer folgende pauschalierte Entschädigung
                vom vereinbarten Auftragswert verlangen:
                <ul className="mt-3 space-y-2 list-disc pl-5">
                  <li>21 bis 15&nbsp;Tage vor dem Termin: <b>30&nbsp;%</b></li>
                  <li>14 bis 8&nbsp;Tage vor dem Termin: <b>50&nbsp;%</b></li>
                  <li>7 bis 3&nbsp;Tage vor dem Termin: <b>70&nbsp;%</b></li>
                  <li>2&nbsp;Tage vor dem Termin bis zum Termin sowie bei Nichtinanspruchnahme
                    der Leistung: <b>90&nbsp;%</b></li>
                </ul>
                <span className="block mt-3">Die Pauschalen orientieren sich am typischerweise
                zu erwartenden Schaden: Der Auftragnehmer blockiert den Termin exklusiv und kann
                ihn kurzfristig regelmäßig nicht mehr anderweitig vergeben, während ein Teil der
                Aufwendungen (insbesondere noch nicht beschaffte Ware) entfällt. Auf die
                Entschädigung werden Einnahmen aus einer anderweitigen Vergabe des freigewordenen
                Termins angerechnet. Dem Verbraucher bleibt ausdrücklich der Nachweis gestattet,
                dass kein oder ein wesentlich geringerer Schaden entstanden ist; in diesem Fall
                reduziert sich die Entschädigung entsprechend oder entfällt.</span>
                <span className="block mt-3">Bereits entstandene und nicht mehr stornierbare
                Waren- oder Fremdkosten (z.&nbsp;B. vorbestellte Spezialprodukte, gemietetes
                Equipment) können zusätzlich in tatsächlicher Höhe berechnet werden, soweit sie in
                der Pauschale noch nicht enthalten sind; bereits beschaffte Ware wird dem
                Auftraggeber übergeben. Eine <b>einmalige Terminverschiebung</b> auf einen
                innerhalb von sechs Monaten liegenden Ersatztermin ist kostenfrei möglich, sofern
                sie spätestens 21&nbsp;Tage vor dem Termin in Textform mitgeteilt wird und der
                Auftragnehmer am Ersatztermin verfügbar ist.</span></li>
              <li><b className="text-[#2C2A26]">4.9 Fotos und Veröffentlichung.</b> Aufnahmen von
                Speisen und Räumlichkeiten zur Veröffentlichung (z.&nbsp;B. Social Media) erfolgen
                nur mit vorheriger Zustimmung des Auftraggebers. Personen werden nicht ohne deren
                Einwilligung erkennbar abgebildet. Eine Zustimmung kann jederzeit widerrufen
                werden.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">5. Sonderbedingungen Koch-Vermittlung</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Für die Vermittlung selbstständiger Köche an gewerbliche Auftraggeber gelten
              ergänzend und vorrangig die folgenden Regelungen. Maßgeblich sind zusätzlich der
              Vermittlungs- und Koordinationsvertrag (mit dem Koch) sowie die
              Provisionsvereinbarung (mit dem Auftraggeber), die vor der ersten Vermittlung
              geschlossen werden.
            </p>
            <ul className="mt-4 space-y-3 text-[#757067] font-light leading-relaxed list-none">
              <li><b className="text-[#2C2A26]">5.1 Stellung des Vermittlers.</b> Der Auftragnehmer
                erbringt ausschließlich eine Vermittlungs- und Koordinationsleistung. Der Vertrag
                über den Einsatz kommt unmittelbar zwischen dem Auftraggeber und dem vermittelten
                Koch zustande; der Auftragnehmer ist insoweit nicht Vertragspartei.</li>
              <li><b className="text-[#2C2A26]">5.2 Keine Arbeitnehmerüberlassung.</b> Der
                vermittelte Koch ist selbstständig tätig, nicht weisungsgebunden und wird nicht in
                die Dienstpläne des Auftraggebers eingebunden. Eine Arbeitnehmerüberlassung im
                Sinne des AÜG liegt nicht vor und ist nicht gewollt. Der Auftraggeber verpflichtet
                sich, den Koch nicht wie eigenes Personal einzusetzen.</li>
              <li><b className="text-[#2C2A26]">5.3 Provision.</b> Die Vermittlungsprovision trägt
                ausschließlich der Auftraggeber. Sie beträgt <b>40,00&nbsp;€ netto je Koch und
                Einsatztag</b>; bei der Vermittlung in ein Arbeitsverhältnis <b>100,00&nbsp;€ netto
                einmalig</b>, jeweils zuzüglich der gesetzlichen Umsatzsteuer. Dem vermittelten
                Koch entstehen keine Kosten. Zahlungsziel: 14&nbsp;Tage netto.</li>
              <li><b className="text-[#2C2A26]">5.3b Vermittlung an Privatkunden.</b> Der Auftragnehmer
                vermittelt selbstständige Köche auch an Privatpersonen für private Anlässe (z.&nbsp;B.
                Private Dining, Geburtstage, Familienfeiern). Es gelten dieselben Regelungen; die
                Provision beträgt <b>47,60&nbsp;€ inkl. 19&nbsp;% Umsatzsteuer</b> (40,00&nbsp;€ netto)
                je Koch und Einsatztag und wird als Endpreis ausgewiesen. Honorar, Menü und Einkauf
                vereinbart der Privatkunde unmittelbar mit dem vermittelten Koch. Dem Koch
                entstehen auch hier keine Kosten. Für Privatkunden gilt zusätzlich die
                Widerrufsbelehrung in Ziffer&nbsp;15a. Dieses Vermittlungsangebot ist getrennt vom
                eigenen Privatkoch-Angebot des Auftragnehmers (Ziffer&nbsp;4), bei dem der
                Auftragnehmer selbst kocht.</li>
              <li><b className="text-[#2C2A26]">5.3a Umsatzsteuer bei Auftraggebern in Österreich.</b>{" "}
                Ist der Auftraggeber Unternehmer mit Sitz in Österreich, wird die Provision als
                innergemeinschaftliche Dienstleistung <b>ohne deutsche Umsatzsteuer</b> abgerechnet; die
                Steuerschuld geht auf den Auftraggeber über (Reverse Charge, Art.&nbsp;196 MwStSystRL,
                §&nbsp;3a&nbsp;Abs.&nbsp;2 UStG, §&nbsp;19&nbsp;Abs.&nbsp;1 öUStG). Der Auftraggeber teilt
                dem Auftragnehmer hierfür seine gültige <b>UID-Nummer</b> mit und hält sie aktuell; sie wird
                im EU-Register (VIES) geprüft. Ohne gültige UID-Nummer kann die Leistung mit
                Umsatzsteuer abgerechnet werden. Für nichtunternehmerische Auftraggeber in Österreich
                gelten die allgemeinen Regelungen.</li>
              <li><b className="text-[#2C2A26]">5.4 Abgesagte Einsätze.</b> Der Provisionsanspruch
                entsteht mit dem Zustandekommen des Einsatzvertrages zwischen Auftraggeber und Koch.
                Sagt der Auftraggeber einen vereinbarten Einsatz weniger als <b>48&nbsp;Stunden</b>
                vor Einsatzbeginn ab oder nimmt er ihn nicht in Anspruch, bleibt die Provision für
                den ersten abgesagten Einsatztag geschuldet; für weitere abgesagte Tage entfällt
                sie. Sagt der Koch ab oder tritt er den Einsatz nicht an, entfällt die Provision
                vollständig. Wird ein Einsatz vorzeitig beendet, fällt die Provision für den
                betreffenden Einsatztag einmalig an.</li>
              <li><b className="text-[#2C2A26]">5.5 Keine Bindung, keine Exklusivität.</b> Provision
                fällt ausschließlich für Einsätze an, die über den Auftragnehmer vereinbart werden.
                Vereinbart der Auftraggeber weitere Einsätze unmittelbar mit einem Koch, entsteht
                kein Provisionsanspruch. Es bestehen <b>kein Kundenschutz, keine Meldepflicht, keine
                Vertragsstrafe, keine Exklusivität und keine Mindestabnahme</b>. Auch der vermittelte
                Koch ist an den Auftragnehmer nicht gebunden und zahlt keine Provision.</li>
              <li><b className="text-[#2C2A26]">5.6 Bestätigung der Einsatztage.</b> Der Auftraggeber
                bestätigt die über den Auftragnehmer vereinbarten Einsatztage auf Anfrage in
                Textform, damit die Provision korrekt abgerechnet werden kann.</li>
              <li><b className="text-[#2C2A26]">5.7 Prüfung und Haftung.</b> Der Auftragnehmer prüft
                die von den Köchen eingereichten Unterlagen auf Vollständigkeit und Plausibilität
                — in Deutschland Gewerbeanmeldung, Lebenslauf und Belehrung nach
                §&nbsp;43&nbsp;IfSG, in Österreich Gewerbeschein, Lebenslauf und Nachweis der
                Lebensmittelhygiene-Schulung nach LMSVG —, schuldet
                jedoch keine Erfolgsgarantie hinsichtlich der fachlichen Eignung. Für die
                Leistungserbringung, deren Qualität und für Schäden aus dem Einsatz haftet
                ausschließlich der vermittelte Koch. Ansprüche sind unmittelbar zwischen
                Auftraggeber und Koch zu klären.</li>
              <li><b className="text-[#2C2A26]">5.8 Unterlagen der Köche.</b> Eingereichte
                Unterlagen werden ausschließlich zum Zweck der Vermittlung verarbeitet und nur nach
                vorheriger Abstimmung mit dem betroffenen Koch an einen Auftraggeber weitergegeben.
                Näheres regelt die Datenschutzerklärung.</li>
              <li><b className="text-[#2C2A26]">5.9 Keine Annahmepflicht.</b> Der vermittelte Koch
                entscheidet in jedem Einzelfall frei über die Annahme eines Auftrags. Ein Anspruch
                des Auftraggebers auf Bereitstellung eines bestimmten Kochs besteht nicht.</li>
            </ul>
          </div>


          <div>
            <h2 className="font-serif text-2xl font-medium">6. Preise und Stundensätze</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed text-sm italic">
              Diese Ziffer gilt für gewerbliche Auftraggeber. Für Verbraucher gelten die
              Festpreis- und Preisangabenregelungen der Ziffern&nbsp;4.1 und&nbsp;4.2.
            </p>
            <ul className="mt-4 text-[#757067] font-light leading-relaxed space-y-2 list-disc pl-5">
              <li>Werktag: 49&nbsp;€ netto pro angefangene Stunde</li>
              <li>Sonn- und Feiertage: 59&nbsp;€ netto pro angefangene Stunde</li>
              <li>Spontanbuchungen (&lt; 24&nbsp;h vor Einsatz): zzgl. 10&nbsp;% auf den Stundensatz</li>
              <li>Ab 3 Tagen Einsatz: reduzierter Stundensatz nach individueller Vereinbarung</li>
              <li>Mindestbuchung: 4&nbsp;Stunden pro Einsatz</li>
            </ul>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Alle Preise verstehen sich zzgl. der jeweils gültigen gesetzlichen Mehrwertsteuer.
              Abweichende Konditionen werden in der Auftragsbestätigung individuell festgehalten.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">7. Abrechnung und Zahlungsbedingungen</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Der in Angebot und Auftragsbestätigung ausgewiesene Rechnungsbetrag stellt eine
              <b> Kalkulation auf Basis der voraussichtlichen Einsatzdauer</b> dar. Die verbindliche
              Endabrechnung erfolgt ausschliesslich nach den <b>tatsächlich geleisteten Arbeitsstunden</b>
              zum vereinbarten Stundensatz. Über- oder Unterschreitungen der kalkulierten Stunden
              werden im Rechnungsbetrag entsprechend berücksichtigt.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Die Abrechnung erfolgt nach tatsächlich erbrachten Arbeitsstunden,
              die durch den Auftraggeber nach Einsatzende elektronisch zu bestätigen
              sind. Die Bestätigung erfolgt über einen vom Auftragnehmer übermittelten
              Bestätigungs-Link. Erfolgt innerhalb von 7&nbsp;Tagen nach Versand kein
              schriftlicher Widerspruch, gelten die übermittelten Stunden als anerkannt.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Der Rechnungsbetrag ist innerhalb von <b>14&nbsp;Tagen</b> nach
              Rechnungsdatum ohne Abzug zur Zahlung fällig. Bei Zahlungsverzug werden
              Verzugszinsen in gesetzlicher Höhe sowie Mahnspesen erhoben.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">8. Stornierung und Ausfallpauschale (Staffel ab 21&nbsp;Tagen)</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed text-sm italic">
              Diese Ziffer gilt für gewerbliche Auftraggeber. Für Verbraucher gilt
              ausschließlich Ziffer&nbsp;4.8 (mit Recht auf Nachweis eines geringeren Schadens).
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Stornierungen müssen in Textform erfolgen. Mit der Auftragsbestätigung wird der
              Einsatztag exklusiv für den Auftraggeber blockiert und nicht mehr an andere Betriebe
              vergeben. Eine Stornierung ist bis einschließlich <b>22&nbsp;Kalendertage</b> vor
              Einsatzbeginn kostenfrei möglich. Danach gelten — bezogen auf die geplante Vergütung
              aus der Auftragsbestätigung — folgende Ausfallpauschalen:
            </p>
            <ul className="mt-4 text-[#757067] font-light leading-relaxed space-y-2 list-disc pl-5">
              <li>21 bis 15&nbsp;Tage vor Einsatzbeginn: <b>40&nbsp;%</b></li>
              <li>14 bis 8&nbsp;Tage vor Einsatzbeginn: <b>60&nbsp;%</b></li>
              <li>7 bis 3&nbsp;Tage vor Einsatzbeginn: <b>80&nbsp;%</b></li>
              <li>Weniger als 3&nbsp;Tage vor Einsatzbeginn, bei Nichterscheinen des Auftraggebers
                oder Nichtinanspruchnahme der Leistung: <b>90&nbsp;%</b></li>
            </ul>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Die Pauschalen entsprechen dem typischerweise zu erwartenden Ausfallschaden, da der
              Einsatztag kurzfristig regelmäßig nicht mehr anderweitig vergeben werden kann.
              Einnahmen aus einer anderweitigen Vergabe des freigewordenen Einsatztags werden
              angerechnet. Dem Auftraggeber bleibt der Nachweis gestattet, dass kein oder ein
              wesentlich geringerer Schaden entstanden ist. Bereits entstandene und nicht mehr
              stornierbare Fremd- und Warenkosten werden zusätzlich in tatsächlicher
              Höhe berechnet, soweit sie in der Pauschale nicht enthalten sind.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Eine <b>einmalige Verschiebung</b> des Einsatzes ist kostenfrei möglich, wenn sie
              spätestens 21&nbsp;Tage vor Einsatzbeginn in Textform mitgeteilt wird und der
              Auftragnehmer am Ersatztermin verfügbar ist. Reduziert der Auftraggeber innerhalb
              der 21-Tage-Frist den Umfang eines mehrtägigen Einsatzes, gilt die Staffel für die
              entfallenden Tage entsprechend.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">9. Haftung</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed text-sm italic">
              Gegenüber Verbrauchern gelten die nachfolgenden Haftungsbeschränkungen nur, soweit
              sie gesetzlich zulässig sind. Die Haftung für Vorsatz und grobe Fahrlässigkeit, für
              Schäden aus der Verletzung von Leben, Körper oder Gesundheit sowie nach dem
              Produkthaftungsgesetz bleibt in jedem Fall unberührt und unbeschränkt.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Der Auftragnehmer haftet ausschliesslich für Schäden, die nachweislich
              durch grobe Fahrlässigkeit oder Vorsatz verursacht wurden. Eine Haftung
              für mittelbare Schäden, Folgeschäden oder entgangenen Gewinn ist
              ausgeschlossen. Der Auftraggeber ist verpflichtet, etwaige Schäden
              unverzüglich, spätestens jedoch innerhalb von 48&nbsp;Stunden nach
              Einsatzende, schriftlich zu rügen.
            </p>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b>Allergien und Unverträglichkeiten:</b> Der Auftraggeber ist verpflichtet,
              sämtliche bekannten Lebensmittelallergien, -unverträglichkeiten und diätetischen
              Anforderungen der Gäste dem Auftragnehmer vor dem Einsatz schriftlich (per
              E-Mail genügt) mitzuteilen. Für gesundheitliche Beeinträchtigungen aufgrund
              nicht mitgeteilter Allergien oder Unverträglichkeiten übernimmt der Auftragnehmer
              keine Haftung. Der Auftragnehmer arbeitet in Fremdküchen, in denen ein
              Kreuzkontakt mit Allergenen (u.&nbsp;a. Gluten, Nüsse, Milch, Ei) nicht
              vollständig ausgeschlossen werden kann.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">10. Höhere Gewalt und Ausfall</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Ist der Auftragnehmer aus Gründen, die er nicht zu vertreten hat
              (u.&nbsp;a. Krankheit, Unfall, behördliche Anordnungen, Naturereignisse), an
              der Erbringung der Leistung gehindert, informiert er den Auftraggeber
              unverzüglich. In diesem Fall wird der Einsatz einvernehmlich verschoben oder
              — sofern zumutbar — durch einen qualifizierten Ersatzkoch erbracht. Bereits
              geleistete Anzahlungen werden bei ersatzloser Absage vollständig zurückerstattet.
              Weitergehende Ansprüche des Auftraggebers sind ausgeschlossen.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">11. Sonderzutaten und Zusatzkosten</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Nach Vertragsschluss vom Auftraggeber gewünschte Sonderzutaten (z.&nbsp;B.
              Trüffel, Kaviar, Wagyu, spezielle Kochweine für Saucen), Zusatzausrüstung oder kurzfristig
              angeforderte Mehrleistungen werden gesondert und zum Selbstkostenpreis in
              Rechnung gestellt. Der Auftragnehmer wird den Auftraggeber vorab über die zu
              erwartenden Kosten informieren und dessen Zustimmung einholen.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">12. Gutscheine (Guthaben-Charakter)</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Über die Website und im Direktvertrieb ausgestellte Gutscheine stellen
              rechtlich Mehrzweck-Gutscheine im Sinne von §&nbsp;3 Abs.&nbsp;15 UStG dar. Der
              Gutscheinbetrag ist ein <b>Guthaben</b>, das bei Einlösung von der individuell
              kalkulierten Endrechnung des Menü- oder Mietkoch-Einsatzes (Personenzahl,
              Gang-Anzahl, Wareneinsatz) abgezogen wird. Der tatsächliche
              Menü-Preis richtet sich nach den bei der Terminabsprache vereinbarten Leistungen
              und wird transparent kalkuliert.
            </p>
            <p className="mt-3 text-[#757067] font-light leading-relaxed">
              Übersteigt die Endrechnung das Guthaben, ist der Restbetrag bei Einlösung
              vom Kunden zu tragen. Ist die Endrechnung geringer als das Guthaben, bleibt
              das verbleibende Restguthaben bis zum Ablauf der Gültigkeit verfügbar und kann
              in mehreren Einsätzen genutzt werden.
            </p>
            <p className="mt-3 text-[#757067] font-light leading-relaxed">
              Gutscheine sind ab dem Ausstellungsdatum drei Jahre lang gültig (§&nbsp;195 BGB),
              frei übertragbar und nicht in bar auszahlbar. Umsatzsteuer wird erst bei
              Einlösung des Gutscheins ausgewiesen.
            </p>
            <p className="mt-3 text-[#757067] font-light leading-relaxed">
              <b>Terminabsage:</b> Bei Absage weniger als 48&nbsp;Stunden vor dem vereinbarten
              Einsatztermin bleibt der Gutschein gültig und kann für einen neuen Termin
              genutzt werden. Die für den ursprünglichen Termin bereits eingekaufte Ware
              (Einkauf üblicherweise ca. 3&nbsp;Tage vor dem Einsatz) wird jedoch vom Guthaben
              abgezogen und dem Kunden am geplanten Termin oder in Absprache übergeben —
              der Auftragnehmer kann nicht auf den bereits verauslagten Warenkosten sitzen
              bleiben. Der Restwert des Gutscheins bleibt bis zum Ablauf verfügbar.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">13. Verschwiegenheit</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Beide Vertragsparteien verpflichten sich, alle im Rahmen des Auftrags
              erlangten geschäftlichen Informationen vertraulich zu behandeln und
              Dritten nicht zugänglich zu machen.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">14. Datenschutz</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Die Verarbeitung personenbezogener Daten richtet sich nach der separaten
              Datenschutzerklärung, die ebenfalls Bestandteil des Vertrags ist.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">15. Widerrufsrecht für Verbraucher</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Ist der Auftraggeber Verbraucher im Sinne des §&nbsp;13 BGB (natürliche Person,
              die den Vertrag zu privaten Zwecken abschliesst), steht ihm das nachfolgende
              Widerrufsrecht zu. Es gilt sowohl für Koch- und Privatkoch-Leistungen des
              Auftragnehmers selbst als auch für die <b>Vermittlung eines Kochs an Privatkunden</b>
              nach Ziffer&nbsp;5.3b. Bei der Vermittlung ist die Dienstleistung vollständig erbracht,
              sobald die Vereinbarung zwischen Privatkunde und vermitteltem Koch zustande gekommen ist;
              mit diesem Zeitpunkt erlischt das Widerrufsrecht, wenn der Kunde dem vorzeitigen Beginn
              zugestimmt hat.
            </p>
            <div className="mt-4 p-5 bg-[#FAF5F1] border-l-4 border-[#BA6D52]">
              <p className="text-[#2C2A26] font-medium mb-3">Widerrufsbelehrung</p>
              <p className="text-[#757067] font-light leading-relaxed text-sm">
                Sie haben das Recht, binnen <b>vierzehn Tagen</b> ohne Angabe von Gründen
                diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab
                dem Tag des Vertragsschlusses.
              </p>
              <p className="mt-3 text-[#757067] font-light leading-relaxed text-sm">
                Um Ihr Widerrufsrecht auszuüben, müssen Sie mir (<b>Lukas Stutz, Schloßstraße&nbsp;32,
                64720 Michelstadt, Deutschland, mietkoch@stutz-cuisine.com</b>) mittels
                einer eindeutigen Erklärung (z.&nbsp;B. per Post oder E-Mail) über Ihren
                Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung der
                Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung
                des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
              </p>
              <p className="mt-3 text-[#757067] font-light leading-relaxed text-sm">
                <b>Folgen des Widerrufs:</b> Widerrufen Sie diesen Vertrag, erstatte ich
                Ihnen alle Zahlungen, die ich von Ihnen erhalten habe, unverzüglich und
                spätestens binnen vierzehn Tagen ab dem Tag, an dem die Mitteilung über
                Ihren Widerruf bei mir eingegangen ist.
              </p>
              <p className="mt-3 text-[#757067] font-light leading-relaxed text-sm">
                <b>Vorzeitiges Erlöschen des Widerrufsrechts:</b> Das Widerrufsrecht
                erlischt bei Dienstleistungen, wenn der Auftragnehmer die Dienstleistung
                vollständig erbracht hat und mit der Ausführung erst begonnen hat, nachdem
                der Verbraucher dazu seine ausdrückliche Zustimmung gegeben und gleichzeitig
                seine Kenntnis davon bestätigt hat, dass er sein Widerrufsrecht bei
                vollständiger Vertragserfüllung durch den Auftragnehmer verliert.
              </p>
              <p className="mt-3 text-[#757067] font-light leading-relaxed text-sm">
                Findet der Einsatz auf ausdrücklichen Wunsch des Verbrauchers <b>vor Ablauf
                der Widerrufsfrist</b> statt, gilt mit der Anfrage bzw. Buchungsbestätigung
                die entsprechende Zustimmung als erteilt. Der Verbraucher hat in diesem Fall
                einen anteiligen Betrag für die bis zum Widerruf bereits erbrachten Leistungen
                zu bezahlen.
              </p>
              <p className="mt-3 text-[#757067] font-light leading-relaxed text-sm">
                <b>Muster-Widerrufsformular:</b> „An Lukas Stutz, Schloßstraße&nbsp;32, 64720
                Michelstadt, mietkoch@stutz-cuisine.com — Hiermit widerrufe(n) ich/wir den von mir/uns
                abgeschlossenen Vertrag über die Erbringung der folgenden Dienstleistung: … Bestellt
                am/Vorgangsnummer: … Name und Anschrift des/der Verbraucher(s): … Datum, Unterschrift."
              </p>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">16. Gerichtsstand und anwendbares Recht</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Es gilt ausschliesslich das Recht der Bundesrepublik Deutschland unter
              Ausschluss des UN-Kaufrechts. Ist der Auftraggeber Kaufmann, juristische
              Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen,
              ist ausschliesslicher Gerichtsstand für alle Streitigkeiten aus diesem
              Vertragsverhältnis der Sitz des Auftragnehmers in <b>64720&nbsp;Michelstadt</b>.
              Gegenüber Verbrauchern gilt der gesetzliche Gerichtsstand. Bei Verbrauchern mit
              Wohnsitz in Österreich bleiben die zwingenden Verbraucherschutzvorschriften des
              österreichischen Rechts unberührt (Art.&nbsp;6 Abs.&nbsp;2 Rom-I-VO); sie können zudem
              an ihrem Wohnsitz klagen und dort verklagt werden.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl font-medium">17. Schlussbestimmungen</h2>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die
              Wirksamkeit der übrigen Bestimmungen davon unberührt. An die Stelle der
              unwirksamen Bestimmung tritt eine Regelung, die dem wirtschaftlichen
              Zweck am nächsten kommt. Änderungen und Ergänzungen bedürfen der
              Schriftform.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}
